import React from 'react';
import { GymStats } from '../../constants/types';
import { formatDateRange } from '../../constants/helpers';
import { SVGs } from '../../constants/Svgs';
import CustomButton from '../UI/CustomButton';
import StatBox from './StatBox';

interface GeneralStatsSectionProps {
    gymStats: GymStats | undefined;
}

const GeneralStatsSection: React.FC<GeneralStatsSectionProps> = ({ gymStats }) => {
    return (
        <div className="flex flex-row gap-4 w-full">
            <div className="flex flex-col bg-white rounded-lg p-4 gap-4 flex-1">
                <div>
                    <div className='flex items-baseline bold large3'>Données générales Gaston<p className='normal'>({formatDateRange()})</p></div>
                    <div className='text-grey-500 regular normal'>Les données d'utilisation de Gaston par les grimpeurs sont comparées à celles du mois précédent</div>
                </div>
                {gymStats &&
                    <div className='flex flex-row gap-6'>
                        <StatBox
                            currentMonthStat={gymStats.connexionsTotal}
                            lastMonthStat={gymStats.lastMonthConnexionsTotal}
                            text='Connexions Gaston'
                        />
                        <StatBox
                            currentMonthStat={gymStats.sessionsTotal}
                            lastMonthStat={gymStats.lastMonthSessionsTotal}
                            text='Séances Créées'
                        />
                        <StatBox
                            currentMonthStat={gymStats.trysTotal}
                            lastMonthStat={gymStats.lastMonthTrysTotal}
                            text='Essais Ajoutés'
                        />
                        <StatBox
                            currentMonthStat={gymStats.distinctConnexions}
                            lastMonthStat={gymStats.lastMonthDistinctConnexions}
                            text='Utilisateurs actifs'
                        />
                    </div>
                }
            </div>
            <div className="flex flex-col bg-white rounded-lg p-3 gap-3 w-72">
                <div className='flex flex-row items-center gap-2'>
                    <CustomButton
                        Svg={SVGs.brilliantIdea}
                    />
                    <div className='bold normal'>Astuce Gaston : comment accéder aux vues détaillées ?</div>
                </div>
                <div className='regular lower'>
                    Clique sur une des rubriques pour accéder à la vue secteur ou à la vue par difficulté
                </div>
            </div>
        </div>
    );
};

export default GeneralStatsSection;
